{
  "header": {
    "nameVariable": {
      "id": "01fa65cd-a012-44d6-9297-8d44691cf891",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=258",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "d2ee0b95-f686-497a-8c20-28730a8c987a",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "stacklight": {
    "colorValues": {
      "0": "off",
      "1": "red",
      "2": "green",
      "3": "blue",
      "4": "yellow",
      "5": "purple",
      "6": "cyan",
      "7": "white"
    },
    "lampsPlaceholderObject": "Monitoring.Stacklight.<OrderedObject>.[PLACEHOLDER]",
    "signalVariable": {
      "id": "cf0c5a55-a8e8-4e94-85fe-043769fe0094",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=310",
      "displayName": "SignalOn",
      "variablePath": "SignalOn",
      "dataType": "Boolean",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "signalOnValue": "true",
    "signalOffValue": "false",
    "sortingVariable": {
      "id": "a816aca4-1b70-48f9-b95b-53bb304a80bc",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=226",
      "displayName": "NumberInList",
      "variablePath": "NumberInList",
      "dataType": "UInteger",
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "hasUnit": false,
      "hasRange": false
    },
    "colorVariable": {
      "id": "e022d6f0-95b5-4ca7-a2a3-f25e88a68767",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=290",
      "displayName": "SignalColor",
      "variablePath": "SignalColor",
      "dataType": "SignalColor",
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "timeline": {
    "variable": {
      "id": "d0e27aab-dc64-4432-9cd2-de58dd069ca5",
      "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
      "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6022",
      "displayName": "CurrentState",
      "variablePath": "Monitoring.LaserSystemStatus.LaserSystemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Off": "#8f8f8f",
      "EnergySaving": "#ffbf00",
      "Idle": "#eaeaea",
      "SetUp": "#0000ff",
      "LaserReady": "#00b20e",
      "Maintenance": "#0065f3",
      "Error": "#ff0000",
      "LaserOn": "#fedc00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "valueVariable": {
                "id": "d6837b4b-bae5-4a5f-bd02-71ddd1141162",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=182",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "valueVariable": {
                "id": "b5b7d4a8-097f-4c4f-8818-edb4a0a7e2de",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "valueVariable": {
                "id": "e40be8f5-7940-410f-ad25-c90e6aa9135a",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=259",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "valueVariable": {
                "id": "f8f0fefe-d3f2-49bc-ae40-eeeabba8b08a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "valueVariable": {
                "id": "416889bd-eec5-4470-9867-731c9e6141a9",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "valueVariable": {
                "id": "c8145fac-8977-4eb8-bba1-9b0a25b15201",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Production",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Recipe Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "fb9f49d3-fc81-4d86-9ff4-056630cfdd31",
                "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6071",
                "displayName": "RecipeName",
                "variablePath": "RecipeName",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Recipe Identifier",
              "showAsLink": false,
              "valueVariable": {
                "id": "0420572d-2066-4417-b96c-4f92583ed7d5",
                "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6072",
                "displayName": "RecipeIdentifier",
                "variablePath": "RecipeIdentifier",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Runs Completed",
              "showAsLink": false,
              "valueVariable": {
                "id": "8b216726-d7ec-4f1f-9c91-6d8a859639b6",
                "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6015",
                "displayName": "RunsCompleted",
                "variablePath": "RunsCompleted",
                "dataType": "UInt64",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ],
          "placeholderObject": "Production.RecipeSettingsAndOverviews.<Recipe>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "fb9f49d3-fc81-4d86-9ff4-056630cfdd31",
            "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
            "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6071",
            "displayName": "RecipeName",
            "variablePath": "RecipeName",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Optional",
            "hasProperties": false
          }
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#eaeaea",
                  "textColor": "#000000",
                  "value": "Idle",
                  "label": "Idle"
                },
                {
                  "backgroundColor": "#fedc00",
                  "textColor": "#000000",
                  "value": "LaserOn",
                  "label": "Laser On"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "LaserReady",
                  "label": "Laser Ready"
                },
                {
                  "backgroundColor": "#0065f3",
                  "textColor": "#ffffff",
                  "value": "Maintenance",
                  "label": "Maintenance"
                },
                {
                  "backgroundColor": "#eaeaea",
                  "textColor": "#000000",
                  "value": "Off",
                  "label": "Off"
                },
                {
                  "backgroundColor": "#0000ff",
                  "textColor": "#ffffff",
                  "value": "SetUp",
                  "label": "SetUp"
                },
                {
                  "backgroundColor": "#0000ff",
                  "textColor": "#000000",
                  "value": "Error",
                  "label": "Error"
                },
                {
                  "backgroundColor": "#ffbf00",
                  "textColor": "#000000",
                  "value": "EnergySaving",
                  "label": "Energy Saving"
                }
              ],
              "label": "Status",
              "valueVariable": {
                "id": "d0e27aab-dc64-4432-9cd2-de58dd069ca5",
                "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6022",
                "displayName": "CurrentState",
                "variablePath": "Monitoring.LaserSystemStatus.LaserSystemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "defaultColorGradient": {
                "startColor": "#00b20e",
                "stopColor": "#00b20e"
              },
              "conditionalColorGradients": [
                {
                  "startColor": "#8B0000",
                  "stopColor": "#8B0000",
                  "comparisonValueVariable": {
                    "id": "291c1b14-59e8-430e-b9ea-c162ac254dg",
                    "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                    "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6068",
                    "displayName": "LowerErrorLevel",
                    "variablePath": "LowerErrorLevel",
                    "dataType": "Number",
                    "valueRank": -1,
                    "modellingRule": "Mandatory",
                    "hasProperties": true,
                    "hasUnit": false,
                    "hasRange": false
                  },
                  "comparisonOperator": "lessThanOrEqualTo"
                },
                {
                  "startColor": "#FF0000",
                  "stopColor": "#FF0000",
                  "comparisonValueVariable": {
                    "id": "291c1b14-59e8-430e-b9ea-c162ac254ddf",
                    "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                    "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6066",
                    "displayName": "LowerWarningLevel",
                    "variablePath": "LowerWarningLevel",
                    "dataType": "Number",
                    "valueRank": -1,
                    "modellingRule": "Mandatory",
                    "hasProperties": true,
                    "hasUnit": false,
                    "hasRange": false
                  },
                  "comparisonOperator": "lessThanOrEqualTo"
                },
                {
                  "startColor": "#8B0000",
                  "stopColor": "#8B0000",
                  "comparisonValueVariable": {
                    "id": "291c1b14-59e8-430e-b9ea-c162ac254dde",
                    "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                    "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6064",
                    "displayName": "UpperErrorLevel",
                    "variablePath": "UpperErrorLevel",
                    "dataType": "Number",
                    "valueRank": -1,
                    "modellingRule": "Mandatory",
                    "hasProperties": true,
                    "hasUnit": false,
                    "hasRange": false
                  },
                  "comparisonOperator": "greaterThanOrEqualTo"
                },
                {
                  "startColor": "#FF0000",
                  "stopColor": "#FF0000",
                  "comparisonValueVariable": {
                    "id": "291c1b14-59e8-430e-b9ea-c162ac254ddd",
                    "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                    "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6008",
                    "displayName": "UpperWarningLevel",
                    "variablePath": "UpperWarningLevel",
                    "dataType": "Number",
                    "valueRank": -1,
                    "modellingRule": "Mandatory",
                    "hasProperties": true,
                    "hasUnit": false,
                    "hasRange": false
                  },
                  "comparisonOperator": "greaterThanOrEqualTo"
                }
              ],
              "valueVariable": {
                "id": "291c1b14-59e8-430e-b9ea-c162ac254ddc",
                "modelUri": "http://opcfoundation.org/UA/LaserSystems/",
                "nodeId": "nsu=http://opcfoundation.org/UA/LaserSystems/;i=6003",
                "displayName": "Value",
                "variablePath": "Value",
                "dataType": "Number",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ],
          "placeholderObject": "Monitoring.ConditionData.<ConditionData>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "8b511f04-a63d-49b0-95ab-2b9414cc640b",
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "nsu=http://opcfoundation.org/UA/MachineTool/;i=234",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
